import { render, staticRenderFns } from "./BookPayment.vue?vue&type=template&id=2014c338&scoped=true&"
import script from "./BookPayment.vue?vue&type=script&lang=js&"
export * from "./BookPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014c338",
  null
  
)

export default component.exports